<template>
    <div style="display: flex; justify-content: center; border-bottom: 3px solid #bbb;">
        <div style="display: flex;align-items: center; width: 80%; margin: 15px 0">
            <div class="user-avatar">
                <img :src="userInfo.user_avatar_url" alt="">
            </div>
            <div class="user-content">
                <p style="font-size: 1.2rem;margin-bottom: 0;">{{ userInfo.user_name }}</p>
                <p style="margin-top: 0;"><a :href="userInfo.pixiv_link">{{ user_id }}</a></p>
                <p>{{ userInfo.user_desc }}</p>
            </div>
            <button class="fllow-btn">关注</button>
        </div>
    </div>
    <br>
    <div style="display: flex; justify-content: center;">
        <Section illust_title="作品列表" :imageData="imageInfos_new"></Section>
    </div>

    <div style="display: flex; justify-content: center;">
        <paginater :count="count" :type="1" @pageChange="pageChange"></paginater>
    </div>
</template>
<script>
import Section from '@/components/Section copy.vue';
import paginater from '@/components/paginater.vue';

export default {
    name: 'userArt',
    data() {
        return {
            imageInfos_new: [],
            count: 8,
            user_id: this.$route.query.user_id,
            userInfo:{
                "user_id": 'user_id',
                "user_name": 'user_name',
                "user_desc": 'user_desc',
                "user_avatar_url": 'user_avatar_url',
                "pixiv_link": 'pixiv_link',
            },
        }
    },
    components: {
        Section,
        paginater,
    },
    created() {
        // console.log(this.user_id);
        var url = "http://localhost:8000/userInfo/" + this.$route.query.user_id;
        this.$axios.get(url).then(res => {
            this.userInfo = res.data.data;
        }).catch(error => {
            console.log(error);
        })

        this.loadData(0);
    },
    methods: {
        loadData(offest) {
            var id = this.$route.query.user_id
            var url = "https://www.vilipix.com/api/v1/picture/public?sort=new&type=0&author_user_id=" + id + "&limit=30&offset=" + (offest * 30);
            this.$axios.get(url).then(res => {
                this.imageInfos_new = res.data.data.rows;
                this.count = res.data.data.count;
            }).catch(error => {
                console.log(error);
            })
        },
        pageChange(offest) {
            this.loadData(offest);
        },
    }
}
</script>

<style scoped>
.user-avatar {
    display: flex;
    min-width: 150px;
    min-height: 150px;
    max-width: 150px;
    max-height: 150px;
    overflow: hidden;
    border-radius: 50%;
}

.user-avatar>img {
    width: 100%;
    height: 100;
    object-fit: cover;
}

.user-content {
    width: 80%;
    text-align: left;
    margin-left: 25px;
}

.user-content>p {
    margin-bottom: 10px;
}
/* .user-content:first-child {
    font-size: 1.2rem;
    margin-bottom: 0;
}
.user-content:nth-child(2) {
    margin-top: 0;
} */

.fllow-btn {
    background-color: rgb(6, 139, 248);
    color: white;
    border-radius: 10px;
    /* font-size: 1rem; */
    width: fit-content;
    height: fit-content;
}

</style>